<script lang="ts">
	import { goto } from '$app/navigation'
	import { appState } from '$lib/app-state.svelte'
	import { cartItems } from '$lib/stores.svelte'
	import Offcanvas from '$lib/public/layout/Offcanvas.svelte'
	import NavLink from '$lib/public/layout/NavLink.svelte'

	let count = $derived($cartItems.reduce((sum, item) => sum + item.quantity, 0))
	let thisOffcanvas = $state() as Offcanvas

	async function logout() {
		goto('/login') // Navigate first to avoid errors referencing session.user

		const res = await fetch('/auth/logout', {
			method: 'POST'
		})
		if (res.ok) {
			appState.user = null
		} else {
			console.error(`Logout not successful: ${res.statusText} (${res.status})`)
		}
		thisOffcanvas.close()
	}

	const onclick = (event?: MouseEvent) => {
		const target = event?.currentTarget as HTMLAnchorElement
		const href = target.getAttribute('href')
		if (!href?.startsWith('#')) thisOffcanvas.close() // cannot open new offcanvas if current one closes
	}
</script>

<Offcanvas bind:this={thisOffcanvas} id="navOffcanvas" title="Navigation">
	<NavLink {onclick} href="/" title="Home page" class="tw:block tw:px-4 tw:py-2" />
	<NavLink {onclick} href="/classes" title="Classes" class="tw:block tw:px-4 tw:py-2" />
	<NavLink {onclick} href="/workshops" title="Workshops" class="tw:block tw:px-4 tw:py-2" />
	<NavLink {onclick} href="/teachers" title="Teachers" class="tw:block tw:px-4 tw:py-2" />
	<NavLink
		{onclick}
		href="/teachertraining"
		title="Teacher Training"
		class="tw:block tw:px-4 tw:py-2" />

	{#if appState.user?.role == 'admin'}
		<NavLink {onclick} href="/admin" title="Administration" class="tw:block tw:px-4 tw:py-2" />
	{/if}

	{#if appState.user && appState.user.role != 'student'}
		<NavLink {onclick} href="/shynet" title="SHYnet" class="tw:block tw:px-4 tw:py-2" />
	{/if}

	{#if !appState.user}
		<div class="tw:w-full tw:h-px tw:bg-gray-200"></div>
		<NavLink {onclick} href="/login" title="Login" class="tw:block tw:px-4 tw:py-2" />
		<NavLink {onclick} href="/register" title="Create account" class="tw:block tw:px-4 tw:py-2" />
	{:else}
		<NavLink {onclick} href="/profile" title="My Profile" class="tw:block tw:px-4 tw:py-2" />
		<NavLink {onclick} href="/history" title="History" class="tw:block tw:w-full tw:px-4 tw:py-2" />
		<button
			onclick={logout}
			class="tw:text-plum tw:w-full tw:text-sm tw:text-start tw:font-medium tw:px-4 tw:py-2 tw:hover:bg-lilac tw:hover:text-white"
			>Sign out</button>
	{/if}
	<div class="tw:w-full tw:h-px tw:bg-gray-200"></div>
	<NavLink {onclick} href="#contactOffcanvas" title="Contact us" class="tw:block tw:px-4 tw:py-2" />
	<NavLink {onclick} href="#cartOffcanvas" class="tw:block tw:w-full tw:px-4 tw:py-2"
		>Cart ({count})
	</NavLink>
</Offcanvas>
